// extracted by mini-css-extract-plugin
export default {"fade-before":"FadeIn_fade-before__43gQg","fade-after":"FadeIn_fade-after__Lx2k3"};